<template>
<div><loader v-if="isLoading" />
<div v-if="!isLoading">
    <div class="form-group" v-show="siteTrsList.length > 0">
        <label class="col-md-2 control-label text-label">Site TRS</label>
        <div class="col-md-10 text-label">
            {{siteTrsList.join(', ')}}
        </div>
    </div>
    <div class="form-group" v-if="historicalTrs.length > 0 && productionAdminEdit">
        <label class="col-md-2 control-label text-label">Historical TRS</label>
        <div class="col-md-10 text-label">
            <tr v-for="trs in historicalTrs" v-bind:key="trs.historicalTrsDate" style="background-color:#edf0f2">
                <td>{{trs.historicalTrsDate}}:&nbsp;&nbsp;{{trs.plssLocationDisplay}}</td>
            </tr>
        </div>
    </div>
    <div v-if="productionAdminEdit" class="form-group">
        <label class="control-label text-label" for="isInsufficientLocationInfo" style="color:red;">Insufficient Location Information</label>
        <input type="checkbox" v-model="location.isInsufficientLocationInfo" class="form-check-input" id="isInsufficientLocationInfo" style="width: 15px; height: 15px;"/>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">Street Address</label>
        <div class="col-md-5" :class="{'form-inline': qaqcEnabled}">
            <input type="text" class="form-control" v-model="location.streetAddress" :style="qaqcInputStype">
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'streetAddress'" :hasAppend="true"></qaqcFormFieldSelect>
        </div>
        <label class="col-md-1 control-label">Town</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <input type="text" class="form-control" v-model="location.town" :style="qaqcInputStype">
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'town'" :hasAppend="true"></qaqcFormFieldSelect>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">Lot-Block</label>
        <div class="col-md-5" :class="{'form-inline': qaqcEnabled}">
            <input type="text" class="form-control" v-model="location.lotBlock" :style="qaqcInputStype">
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'lotBlock'" :hasAppend="true"></qaqcFormFieldSelect>
        </div>
        <label class="col-md-1 control-label">Parcel</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <input type="text" class="form-control" v-model="location.parcel" :style="qaqcInputStype">
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'parcel'" :hasAppend="true"></qaqcFormFieldSelect>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">Access Notes</label>
        <div class="col-md-6">
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'accessNotes'" :hasAppend="true"></qaqcFormFieldSelect>
            <textarea class="form-control" v-model="location.accessNotes" rows="6" :style="qaqcInputStype"/>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">Datum</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <select name="Datum" class="form-control" v-model.number="location.datumId" :style="qaqcInputStype">
                <option disabled value="">Select Datum</option>
                <option v-for="datum in datumList" v-bind:value="datum.id" :key="datum.id">
                    {{ datum.description}}
                </option>
            </select>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'datumId'" ></qaqcFormFieldSelect>
        </div>
        <div class="col-md-1"></div>
        <label class="col-md-1 control-label">Easting</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <input type="text" name='easting' class="form-control" :style="qaqcInputStype" v-model="location.easting" data-vv-delay="1000" v-validate="{validUtm: [location.utmZoneId, 'Easting']}">
            <span v-show="errors.has('easting')" class="has-error">{{errors.first('easting') }}</span>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'easting'" ></qaqcFormFieldSelect>
        </div>
    </div>
    <div class="form-group">
        <label class="col-md-2 control-label">UTM Zone</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <select name="UTMZone" class="form-control" v-model.number="location.utmZoneId" :style="qaqcInputStype">
                <option disabled value="">Select UTM Zone</option>
                <option v-for="utm in utmList" v-bind:value="utm.id" :key="utm.id">
                    {{ utm.description}}
                </option>
            </select>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'utmZoneId'" ></qaqcFormFieldSelect>
        </div>
        <div class="col-md-1"></div>
        <label class="col-md-1 control-label">Northing</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <input type="text" name='northing' class="form-control" :style="qaqcInputStype" v-model="location.northing" data-vv-delay="1000" v-validate="{validUtm: [location.utmZoneId, 'Northing']}">
            <span v-show="errors.has('northing')" class="has-error">{{errors.first('northing') }}</span>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'northing'" />
        </div>
    </div>
    <div v-if="!(qaqcEnabled || formDisabled)" class="form-group">
        <div class="col-md-2">
            <button class="btn btn-primary pull-right" v-on:click="saveLocation">Save</button>
        </div>
    </div>
    <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'location'" :completeSection="completeSection"></qaqcFormFieldFooter>
</div></div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import locationService from '../../services/siteForm/locationService'
import lookupService from '../../services/lookup/lookupService'
// import qaqcService from '@/services/qaqcService'
//import culturalResourceRecordingService from '../../services/culturalResourceRecordingService'

import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import loader from '../Loader.vue'

export default {
    name: 'locationForm',
    components: {
        loader,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null },
        siteTrsList: { default: () => [] },
        productionAdminEdit: { default: false },
        historicalTrs: { default: () => [] }
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: false,
            datumList: [],
            utmList: [],
            location: {
                culturalResourceRecordingId: this.crrId
            }
        }
    },
    computed: {
        // styling for input width during qaqc
        qaqcInputStype: function () {
            if (this.qaqcEnabled) {
                return { width: '75%' }
            } else {
                return {}
            }
        },
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // if there's no location qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.location) {
                //     this.qaqcProgressDto.qaqcSelections.location = qaqcService.qaqcSelections().location
                // }
                return this.qaqcProgressDto.qaqcSelections.location
            } else {
                return {}
            }
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        this.log('mounted')
        if (this.crrId) {
            this.loadData().then(result => {
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'LocationForm', message)
        },
        loadData () {
            this.log('Loading data for crrId:' + this.crrId)
            this.loadDatumList()
            this.loadUtmList()
            var searchDto = {culturalResourceRecordingId: this.crrId}
            return locationService.search(this.$http, searchDto).then(response => {
                if (response.data.length > 0) {
                    this.log('found a location')
                    this.location = response.data[0]
                } else {
                    this.log('no location found: ' + response.data.length)
                }
            })
        },
        loadDatumList () {
            loggingService.log(this.isDebug, 'LocationForm', 'loadDatumList')
            return lookupService.listLookup(this.$http, 'Datum').then(response => {
                this.datumList = response.data
                return response
            })
        },
        loadUtmList () {
            loggingService.log(this.isDebug, 'LocationForm', 'loadUtmList')
            return lookupService.listLookup(this.$http, 'UtmZone').then(response => {
                this.utmList = response.data
                return response
            })
        },
        saveLocation () {
            locationService.put(this.$http, this.location).then(response => {
                this.loadData()
            })
        },
        completeSection (sectionName) {
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveLocation()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// LocationForm.vue?5af0e600